import { create } from "apisauce";
const REACT_APP_API_BASE = process.env.REACT_APP_API_BASE;

const api = create({
  baseURL: REACT_APP_API_BASE,
  // baseURL: "http://localhost:3901/api/",
});

export default api;
